export const HEALTH_HISTORY_IDS = {
  HISTORY_OF_PRESENT_ILLNESS: "history_of_present_illness",
  PSYCHIATRIC_HISTORY: "psychiatric_history",
  MEDICAL_HISTORY: "medical_history",
  SYMPTOM_PROGRESSION_OVER_TIME: "symptom_progression_over_time",
} as const;

export const PERSONAL_LIFE_HISTORY_IDS = {
  SUBSTANCE_HISTORY: "substance_history",
  PAST_PERSONAL_HISTORY: "past_personal_history",
  EDUCATIONAL_HISTORY: "educational_history",
  FAMILY_HISTORY: "family_history",
} as const;

export const PREVIEW_TITLE_CODES = {
  HEALTH_HISTORY: "health_history",
  PERSONAL_LIFE_HISTORY: "personal_life_history",
  FUNCTIONAL_DOMAINS: "functional_domains",
} as const;

export const ALL_HEALTH_HISTORY_IDS = Object.values(HEALTH_HISTORY_IDS);

export const ALL_PERSONAL_LIFE_HISTORY_IDS = Object.values(
  PERSONAL_LIFE_HISTORY_IDS,
);
